import React from 'react';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ errorInfo });

        // eslint-disable-next-line no-console
        console.error('UI crashed:', error);
        // eslint-disable-next-line no-console
        console.error('Component stack:', errorInfo?.componentStack);
    }

    render() {
        if (this.state.hasError) {
            const message = this.state.error?.message || String(this.state.error);
            const stack = this.state.errorInfo?.componentStack || '';

            return (
                <div style={{ padding: 16, fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif' }}>
                    <h2 style={{ marginTop: 0 }}>Ошибка интерфейса</h2>
                    <p style={{ marginBottom: 8 }}>
                        Приложение упало при рендере. Ниже — технические детали, которые помогут быстро найти проблемный компонент.
                    </p>
                    <div style={{ background: '#fee', border: '1px solid #f99', padding: 12, borderRadius: 8 }}>
                        <div style={{ fontWeight: 600, marginBottom: 8 }}>Сообщение</div>
                        <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{message}</pre>
                    </div>
                    {stack && (
                        <div style={{ marginTop: 12, background: '#f7f7f7', border: '1px solid #ddd', padding: 12, borderRadius: 8 }}>
                            <div style={{ fontWeight: 600, marginBottom: 8 }}>Component stack</div>
                            <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{stack}</pre>
                        </div>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}
